<template>
    <v-content>
        <v-container fluid fill-height>
            <v-toolbar fixed dark color="error" class="">
                <v-toolbar-title class="text-center">仁翔药业抽奖平台</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-form ref="ruleForm2" class="login-form">
                        <v-text-field :rules="rules2.account" v-model="ruleForm2.account"
                                      prepend-icon="person" name="login" label="请输入您的仁翔药购网登陆账号"
                                      type="text"></v-text-field>
                        <v-text-field v-if="false" :rules="rules2.checkPass" v-model="ruleForm2.checkPass" id="password"
                                      prepend-icon="lock" name="password" readonly label="密码"
                                      type="password"></v-text-field>

                        <p style="margin-top:40px;">登陆仁翔药购网APP，选择界面右下角"我的"，查看左上角即为您本人账号</p>
                        <p>或登陆仁翔药购网网页版，选择"我的药购网即为您本人账号"</p>
                    </v-form>
                    <v-btn color="error" @click="handleSubmit2" class="white--text login">登陆</v-btn>

                    <my-snack-bar :snackbar-content="snackbarOption.text"
                                  :snackbar-show="snackbarOption.show"
                                  :snackbar-hint-type="snackbarOption.hintType"
                                  @close="handleSnackbarClose"></my-snack-bar>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import NProgress from 'nprogress'
    import {mapGetters} from 'vuex'
    import MySnackBar from '../components/Snackbar'
    import {snackbarOption} from "../common/js/snackbar";

    export default {
        name: 'UserLogin',
        components: {
            MySnackBar
        },
        data() {
            return {
                logining: false,
                ruleForm2: {
                    account: '',
                    checkPass: '8888'
                },
                rules2: {
                    account: [
                        v => !!v || '请输入登陆名',
                        v => (v && v.length <= 20) || '登陆名不能超过20个字符'
                    ],
                    checkPass: [
                        v => !!v || '请输入密码'
                    ]
                },
                checked: true,
                snackbarOption
            };
        },
        methods: {
            ...mapGetters('weChat', ['currWeChatUser']),

            handleReset2() {
                this.$refs.ruleForm2.resetFields();
            },
            handleSnackbarClose() {
                this.snackbarOption.show = false
                this.snackbarOption.hintType = ''
                this.snackbarOption.text = ''
            },
            handleSubmit2(ev) {
                if (this.$refs.ruleForm2.validate()) {
                    this.logining = true;
                    NProgress.start();
                    //let wechatUser = localStorage.getItem("wechatUser")

                    let loginParams = {
                        loginName: this.ruleForm2.account, password: this.ruleForm2.checkPass,
                    }
                    this.$store.dispatch("employee/login", loginParams)
                        .then(response => {
                            this.logining = false;
                            NProgress.done();
                            console.log(response.data)
                            if (!response.data.success || response.data.message === "用户名或密码错误") {
                                this.callSnack(response.data.message)
                            } else {
                                this.$router.push({path: '/luck-draw'})
                            }
                        });
                } else {
                    console.log('error submit!!')
                    return false
                }
            },
            callSnack(message) {
                this.snackbarOption.show = true
                this.snackbarOption.hintType = this.snackbarOption.typeEnum.error
                this.snackbarOption.text = message
            }
        }
    }
</script>

<style scoped lang="scss">
    .login {
        width: 150px;
        margin: 35px auto;
        display: block;
        padding: 0;
    }

    .login-form {
        padding: 0px 25px;
    }
</style>



// WEBPACK FOOTER //
// userLogin.vue?6122c334